import { apiCall, API_CONFIG } from './api';

export const eventLogAPI = {
  getEventLogsByFilter: async (
    userId = '',
    type = '',
    page = 1,
    limit = 30,
    dateFilter = 'today',
    startDate = '',
    endDate = '',
    query = ''
  ) => {
    try {
      const payload = {
        page,
        limit,
        dateFilter,
      };

      if (userId) payload.userId = userId;
      if (type) payload.type = type;
      if (query) payload.query = query;
      if (dateFilter === 'custom') {
        if (startDate) payload.startDate = startDate;
        if (endDate) payload.endDate = endDate;
      }

      const response = await apiCall(API_CONFIG.ENDPOINTS.EVENT_LOGS, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (response.success) {
        return {
          success: true,
          data: response.data?.data,
          pagination: response.data?.pagination,
          msg: response.msg,
        };
      }

      return {
        success: false,
        data: [],
        pagination: null,
        message: response.msg || 'Failed to fetch event logs',
      };
    } catch (error) {
      console.error('Error fetching event logs:', error);
      return {
        success: false,
        data: [],
        pagination: null,
        message: error.message || 'Network error occurred',
      };
    }
  },

  getEventLogUsers: async () => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.EVENT_LOG_USERS, {
        method: 'GET',
      });

      if (response.success) {
        return {
          success: true,
          data: response.data,
          msg: response.msg || 'Users fetched successfully',
        };
      }

      return {
        success: false,
        data: [],
        message: response.msg || 'Failed to fetch users',
      };
    } catch (error) {
      console.error('Error fetching users:', error);
      return {
        success: false,
        data: [],
        message: error.message || 'Network error occurred',
      };
    }
  },
};
